export default __webpack_public_path__ + "static/media/learning-background.a462ccc5.svg";